
import ContactMeForm from "../contactMeForm/ContactMeForm";

const ContactMe = () => {

    return (
        <div className="flex justify-center">
            <div className="w-full max-w-[1280px] flex flex-col-reverse lg:flex-col gap-y-[150px] lg:gap-y-0">
                <div className="w-full max-w-[1280px] flex flex-col items-center">
                    <div className="w-full max-w-[1280px] pb-10 flex justify-center text-4xl text-animate">
                        Contact me
                    </div>
                    
                    <ContactMeForm />
                </div>
            </div>
        </div>
    );
};

export default ContactMe;